


































import { Vue, Component } from "vue-property-decorator";

import SudokuBoard, { isValid, newBoard } from "@/@modules/Sudoku/SudokuBoard";
import BacktrackingSolver from "@/@modules/Sudoku/BacktrackingSolver";
import InformedSolver from "@/@modules/Sudoku/InformedSolver";

import SudokuBoardComp from "@/components/SudokuBoard.vue";
import SudokuSolver from "@/@types/SudokuSolver";

@Component({ components: { SudokuBoardComp } })
export default class DefaultView extends Vue {
  originalBoard = newBoard();
  board = newBoard();

  animate: boolean = true;
  cancel: boolean = false;
  solving: boolean = false;

  delay: number = 25;

  created() {
    this.board = [
      [0, 0, 0, 0, 9, 4, 0, 0, 0],
      [0, 0, 5, 3, 0, 0, 7, 0, 2],
      [0, 0, 9, 0, 0, 0, 0, 8, 0],
      [0, 0, 4, 0, 0, 7, 0, 0, 6],
      [2, 0, 1, 0, 0, 0, 5, 0, 9],
      [7, 0, 0, 6, 0, 0, 4, 0, 0],
      [0, 5, 0, 0, 0, 0, 9, 0, 0],
      [8, 0, 6, 0, 0, 1, 3, 0, 0],
      [0, 0, 0, 8, 6, 0, 0, 0, 0],
    ];
  }

  reset() {
    this.board = newBoard();
    this.originalBoard = newBoard();
  }

  clearSolution() {
    this.board = newBoard(this.originalBoard);
  }

  solve(solver: SudokuSolver) {
    if (!isValid(this.board)) {
      alert("The provided puzzle was invalid.");
      return;
    }

    this.originalBoard = newBoard(this.board);
    this.cancel = false;
    // const delay = this.delay;

    const solution = solver.solve(this.board);
    let iter = solution.next();

    if (this.animate) {
      this.solving = true;

      const stepFunc = () => {
        if (iter.done && !iter.value)
          alert(`The given board could not be solved`);

        if (iter.done || this.cancel) {
          this.solving = false;
          return;
        }

        iter = solution.next();
        setTimeout(stepFunc, this.delay || 0);
      };

      setTimeout(stepFunc, this.delay || 0);
      return;
    }

    while (!iter.done) {
      iter = solution.next();
    }
    if (!iter.value) alert(`The given board could not be solved`);
  }

  solveBacktrack() {
    this.solve(new BacktrackingSolver());
  }

  solveInformed() {
    this.solve(new InformedSolver());
  }
}
